import { auth } from 'types';
import { TQueryDefWrapper } from 'types/network';

const mapAuthResp = (data: TQueryDefWrapper<auth.TAuthResp>) => {
    if (
        data &&
        typeof data !== 'string' &&
        ('isSuperAdmin' in data || 'isApproverAdmin' in data)
    ) {
        return {
            userData: data,
        };
    }
    return null;
};

export default mapAuthResp;
